import * as React from 'react'
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar'
import MuiAlert, { AlertProps } from '@mui/material/Alert'

export interface State extends SnackbarOrigin {
  open: boolean
  key?: string
}

interface Message {
  message: string
  key?: string
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

const ErrorSnackBar: React.FC<Message> = (props): JSX.Element => {
  const str = (Math.random() + 1).toString(36).substring(2)
  const [state, setState] = React.useState<State>({
    open: true,
    vertical: 'top',
    horizontal: 'right',
    key: props?.key || str,
  })
  const { vertical, horizontal, open, key } = state

  const handleClose = () => {
    setState({ ...state, open: false })
  }

  return (
    <div key={key}>
      <Snackbar open={open} anchorOrigin={{ vertical, horizontal }} autoHideDuration={8000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
          {props.message}
        </Alert>
      </Snackbar>
    </div>
  )
}

export default ErrorSnackBar
